import React from 'react'
import classNames from 'classnames'

import { Icon } from '@zambezi/sdk/icons'

import OverviewCard from './OverviewCard'
import style from './Overview.module.css'

const Overview = ({
  isStaffMember,
  showMortgageConsents,
  isPayMeYouEnabled,
}) => {
  return (
    <section className={classNames(style.dashboard, 'js-overview')}>
      <header className={`${style.header} js-page-title`}>
        <h1 className={`${style.title}`}>Connections</h1>
        <p className={`${style.subtitle} js-page-summary`}>
          View all your payments and data sharing connections you’ve put in
          place with various apps and websites.
        </p>
      </header>
      <div
        className={classNames(style.group, 'js-section-cards js-section-ob')}
      >
        <h2 className={style.groupTitle}>Open banking connections</h2>
        <div className={style.cards}>
          <OverviewCard
            title="Account information"
            message="Service providers you're sharing data with"
            type="access"
            path="/access-agreements/tpps"
          />
          <OverviewCard
            title="Recurring payments"
            message="Recurring payments and Standing orders set up through service providers"
            type="recurringPayments"
            path="/recurring-payments/vrp/tpps"
          />
          <OverviewCard
            title="Fund checks"
            message="Funds checks carried out by service providers"
            type="fundsCheck"
            path="/funds-checks/tpps"
          />
          <OverviewCard
            title="Payments and transfers"
            message="Payments set up through service providers"
            type="payments"
            path="/payments"
          />
          <OverviewCard empty />
          <OverviewCard empty />
        </div>
      </div>
      {showMortgageConsents && (
        <div className={classNames(style.group, 'js-section-other')}>
          <h2 className={style.groupTitle}>Other connections</h2>
          <div className={style.cards}>
            <OverviewCard
              title="Mortgages"
              message="Mortgage data being shared with service providers"
              type="mortgages"
              path="/mortgages"
            />
            <OverviewCard empty />
            <OverviewCard empty />
            <OverviewCard empty />
          </div>
        </div>
      )}
      {isStaffMember && (
        <div className={classNames(style.group, 'js-section-staff')}>
          <h2 className={style.groupTitle}>Staff only access</h2>
          <div className={style.cards}>
            <OverviewCard
              title="Biometrics"
              message="Customer's registered biometrics using the mobile app for approval requests"
              type="biometrics"
              path="/biometrics"
              icon={
                <Icon
                  name="view-small"
                  className={style.icon}
                  aria-hidden="true"
                />
              }
            />
            {isPayMeYouEnabled ? (
              <OverviewCard
                title="Pay me and Pay you"
                message="Payments set up through third parties"
                type="payMeYou"
                path="/paymeyou"
              />
            ) : (
              <OverviewCard empty />
            )}

            <OverviewCard empty />
            <OverviewCard empty />
          </div>
        </div>
      )}
    </section>
  )
}

export default Overview
